import { Backdrop, CircularProgress } from "@mui/material";
import React from "react";

interface Props {
  loading: boolean;
  children: React.ReactNode;
}

const SpinnerArea: React.FC<Props> = ({ loading = false, children }) => (
  <>
    {children}
    <Backdrop sx={{ color: "#fff" }} open={loading}>
      <CircularProgress color="inherit" />
    </Backdrop>
  </>
);

export default React.memo(SpinnerArea);
